import { render, staticRenderFns } from "./AdminSalesPage.vue?vue&type=template&id=0a67f6c5&scoped=true&"
import script from "./AdminSalesPage.vue?vue&type=script&lang=js&"
export * from "./AdminSalesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a67f6c5",
  null
  
)

export default component.exports